module.exports = __webpack_public_path__ + "img/JordanPicRound2.215571ec.jpeg";